module.exports = __webpack_public_path__ + "img/3.8721c096.png";